export const shiftControlConstants = {
    GET_SUCCESS: 'GET_SHIFT_CONTROL_SUCCESS',
};
